import React from 'react'
import './style/weekHot.css'
import { encode } from 'js-base64'
import { useLocation } from 'react-router-dom'
export default function WeekHot(hot) {
  //获取路由参数
  const { pathname } = useLocation()

  return (
    <div className="hotlist">
      <div className="hot">本周热门</div>
      <div className="xhq"></div>
      <ul>
        {hot.hot.map((item, index) => (
          <li
            className="hot_li"
            key={index}
            onClick={() => {
              window.open(
                `/#${pathname}/${item.id}?item=${encode(JSON.stringify(item))}`,
                '_blank'
              )
            }}>
            <div className="li-left">
              <span id="rankname">{index + 1}</span>
            </div>
            <div className="li-center">
              <span className="name">{item.soft_name}</span>
              <span className="info">{item.short_desc}</span>
            </div>
            <div className="li-right">
              <img src={item.icon_url} alt="" />
            </div>
          </li>
        ))}
      </ul>
    </div>
  )
}
